import axios from 'axios';
import { authHeader } from './utils';
import { GET_NOTICE, LIST_NOTICE } from './types';

export const getNotice = (id) => async (dispatch) => {
  const res = await axios.get(`/api/notices/${id}`, {
    headers: authHeader(),
  });
  console.log('res', res.data);
  dispatch({ type: GET_NOTICE, payload: res.data });
};

export const fetchNotices = (page, limit) => async (dispatch) => {
  const res = await axios.get('/api/notices', {
    headers: authHeader(),
    params: { page, limit },
  });
  console.log('res', res.data);
  dispatch({ type: LIST_NOTICE, payload: res.data });
};

export const submitNotice =
  ({ notice }, navigate) =>
  async (dispatch) => {
    const res = await axios.post('/api/notices', notice, {
      headers: authHeader(),
    });
    navigate('/notices');
  };

export const updateNotice =
  ({ notice, id }, navigate) =>
  async (dispatch) => {
    const res = await axios.put(`/api/notices/${id}`, notice, {
      headers: authHeader(),
    });
    navigate('/notices');
  };

export const deleteNotice =
  ({ id }, navigate) =>
  async (dispatch) => {
    try {
      const res = await axios.delete(`/api/notices/${id}`, {
        headers: authHeader(),
      });
      navigate('/notices');
    } catch (error) {
      console.log(error);
    }
  };
